// extracted by mini-css-extract-plugin
export default {"left":"CfGcqiJ9jFtNc9LLr_mZ","icon":"sUN6OSSJ8VN9l8ydlTuM"};